export default __webpack_public_path__ + "static/media/arrow_less.da912c2f.svg";